import {MolbioFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';

export function areAaMonomersEnabledForUser(): boolean {
  return (
    BenchlingConfig.MOLBIO_ENABLE_AA_MONOMER_LIBRARY && isFeatureEnabled({feature: MolbioFeature.MOLBIO_OPEN})
  );
}
